module.exports = __webpack_public_path__ + "static/media/Lexy-Full-Body.623e4776.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Lexy-Full-Body.png
// module id = 103
// module chunks = 0